// Predefined stipulations list used by EditShow (Single and Tag Team first, others alphabetized)
const BASE_STIPULATIONS = [
    'No Disqualification',
    'No Holds Barred',
    'Extreme Rules',
    'Ladder',
    'Tables',
    'TLC',
    'Steel Cage',
    'Hell in a Cell',
    'Falls Count Anywhere',
    'Street Fight',
    'Submission',
    'I Quit',
    'Ironman',
    'Last Man Standing',
    '2-out-of-3 Falls',
    'Tornado Tag Team',
    'Mixed Tag Team',
    'Triple Threat',
    'Fatal 4-Way',
    'Six-Pack Challenge',
    'Handicap',
    'Gauntlet',
    'Iron Survivor Challenge',
    'Elimination Chamber',
    'Money in the Bank ladder',
    'WarGames',
    'Battle Royal',
    'Royal Rumble',
    'King of the Ring tournament final',
    'Queen of the Ring tournament final',
    '6-Man Tag Team',
    '8-Man Tag Team',
    '10-Man Tag Team',
    '12-Man Tag Team',
    'Tornado 6-Man Tag Team',
    'Tornado 8-Man Tag Team',
    'Triple Threat Tag Team',
    'Fatal 4-Way Tag Team',
    'Triple Threat Elimination',
    'Fatal 4-Way Elimination',
    'Fatal 5-Way Elimination',
    'Six-Pack Challenge Elimination',
    'Elimination Tag Team',
    'Traditional Survivor Series Elimination ',
    'Tornado Elimination Tag Team',
    'Elimination 6-Man Tag Team',
    'Elimination 8-Man Tag Team',
    'Tag Team Turmoil',
    'Gauntlet Tag Team',
    'Three Stages of Hell',
    'Two out of Three Falls Tag Team',
    'Ambulance',

];

// Ensure 'Single' and 'Tag Team' are first, then the rest alphabetized (case-insensitive)
export const STIPULATIONS = [
    'Single',
    'Tag Team',
    ...BASE_STIPULATIONS.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
];

export default STIPULATIONS;
